import { render, staticRenderFns } from "./Page500.vue?vue&type=template&id=44527f0a&scoped=true&"
var script = {}
import style0 from "./Page500.vue?vue&type=style&index=0&id=44527f0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44527f0a",
  null
  
)

export default component.exports